import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";

const BASE_URL = "https://partyhousedatabase-rpft.onrender.com";

export default function AdminAddingRooms() {
  const { id } = useParams(); // if editing
  const navigate = useNavigate();

  const [formData, setFormData] = useState({
    name: "",
    capacity: "",
    price: "",
    description: "",
    image_file: null,
    image_url: "",
  });

  // ---------- Load room if editing ----------
  useEffect(() => {
    if (id) {
      fetch(`${BASE_URL}/rooms/${id}`)
        .then(res => res.json())
      .then(data => {
  console.log("ROOM DATA:", data);

  setFormData({
    name: data?.name || "",
    capacity: data?.capacity || "",
    price: data?.price || "",
    description: data?.description || "",
    image_file: null,
    image_url: data?.image_url || "",
  });
})
        .catch(err => console.error(err));
    }
  }, [id]);

  // ---------- Input Change ----------
  const handleChange = (field, value) => {
    setFormData(prev => ({ ...prev, [field]: value }));
  };

  // ---------- File Input ----------
  const handleFileChange = (e) => {
    const file = e.target.files[0];
    setFormData(prev => ({ ...prev, image_file: file }));
  };

  // ---------- Submit ----------
 const handleSubmit = async (e) => {
  e.preventDefault();

  const form = new FormData();
  form.append("name", formData.name);
  form.append("capacity", formData.capacity);
  form.append("price", formData.price);
  form.append("description", formData.description);

  // Send either new file or existing URL
  if (formData.image_file) {
    form.append("image_url", formData.image_file);
  } else if (formData.image_url) {
    form.append("image_url", formData.image_url);
  }

  const url = id ? `${BASE_URL}/rooms/update/${id}` : `${BASE_URL}/rooms/add`;
  const method = id ? "PUT" : "POST";

  try {
    const res = await fetch(url, { method, body: form });
    const data = await res.json();

    if (res.ok) {
      alert(data.message);
      navigate("/admin/rooms-list");
    } else {
      alert(data.error || "Error occurred");
    }
  } catch (err) {
    console.error(err);
    alert("Server error");
  }
};


  return (
    <div style={{ padding: "40px", fontFamily: "'Segoe UI', sans-serif" }}>
      <h1 style={{ textAlign: "center", marginBottom: "30px" }}>
        {id ? "Edit Room" : "Add Room"}
      </h1>

      <form
        onSubmit={handleSubmit}
        style={{
          maxWidth: "600px",
          margin: "0 auto",
          display: "flex",
          flexDirection: "column",
          gap: "15px"
        }}
      >
        <input
          type="text"
          placeholder="Room Name *"
          value={formData.name}
          onChange={e => handleChange("name", e.target.value)}
          required
          style={inputStyle}
        />

        <input
          type="number"
          placeholder="Capacity *"
          value={formData.capacity}
          onChange={e => handleChange("capacity", e.target.value)}
          required
          min="1"
          style={inputStyle}
        />

        <input
          type="number"
          placeholder="Price per Day *"
          value={formData.price}
          onChange={e => handleChange("price", e.target.value)}
          required
          min="0"
          style={inputStyle}
        />

        <textarea
          placeholder="Description"
          value={formData.description}
          onChange={e => handleChange("description", e.target.value)}
          rows="4"
          style={{ ...inputStyle, resize: "vertical" }}
        />

        {/* Image File Upload */}
        <input
          type="file"
          accept="image/*"
          onChange={handleFileChange}
          style={inputStyle}
        />

        {/* Preview selected image */}
        {formData.image_file && (
          <img
            src={URL.createObjectURL(formData.image_file)}
            alt="Preview"
            style={{ width: "150px", borderRadius: "12px" }}
          />
        )}

        {/* Show existing image if editing */}
        {!formData.image_file && formData.image_url && (
          <img
            src={formData.image_url}
            alt="Existing"
            style={{ width: "150px", borderRadius: "12px" }}
          />
        )}

        <button type="submit" style={buttonStyle}>
          {id ? "Update Room" : "Add Room"}
        </button>
      </form>
    </div>
  );
}

// Styles
const inputStyle = {
  width: "100%",
  padding: "12px 15px",
  borderRadius: "10px",
  border: "1px solid #ccc",
  fontSize: "16px",
  outline: "none"
};

const buttonStyle = {
  padding: "12px",
  borderRadius: "50px",
  border: "none",
  background: "#007bff",
  color: "#fff",
  fontSize: "16px",
  fontWeight: "bold",
  cursor: "pointer"
};
